import { Sparkles } from "lucide-react";

export default function Wordmark({ size = 28, withTagline = false }) {
  return (
    <div className="inline-flex flex-col" data-testid="opstrai-wordmark">
      <div
        className="opstrai-wordmark"
        style={{ fontSize: `${size}px` }}
        aria-label="Opstrait"
      >
        <span>OPSTR</span>
        <span className="ai">AIT</span>
      </div>
      {withTagline && (
        <div className="opstrai-tagline mt-2">
          Strata operations, powered by AI
        </div>
      )}
    </div>
  );
}

export function AiBadge({ label = "Powered by Claude Sonnet 4.5" }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium"
      style={{
        background: "var(--blue-light)",
        color: "var(--blue-dark)",
        letterSpacing: "0.02em",
      }}
      data-testid="ai-badge"
    >
      <Sparkles size={11} strokeWidth={2.5} />
      {label}
    </span>
  );
}
